import React, { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name || !formData.email || !formData.message) {
      alert("Please complete all payload fields.");
      return;
    }
    setSubmitted(true);
    setTimeout(() => {
      alert("🚀 API Payload dispatched successfully! Muhammad Haidar Shahab (Lead Systems Architect) has received your request.");
      setFormData({ name: '', email: '', message: '' });
      setSubmitted(false);
    }, 600);
  };

  return (
    <section id="contact" className="pt-32 pb-28 bg-slate-950 text-slate-100 relative overflow-hidden bg-cyber-grid border-t border-emerald-500/20">
      <div className="container mx-auto px-4">
        <div className="w-full">
          <div className="mx-auto mb-16 max-w-xl text-center">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-emerald-500/10 border border-emerald-500/30 text-emerald-400 font-mono text-xs font-bold uppercase tracking-widest mb-4">
              📡 API REQUEST DISPATCHER
            </div>
            <h2 className="mb-4 text-3xl font-black text-white sm:text-4xl lg:text-5xl tracking-tight">
              Connect with <span className="text-emerald-400">Muhammad Haidar Shahab</span>
            </h2>
            <p className="text-sm font-normal text-slate-400 leading-relaxed">
              Have a full-stack engineering requirement, software architecture project, or interest in AI Agent systems? Dispatch a request payload below.
            </p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="cyber-card mx-auto max-w-2xl bg-slate-900/90 p-8 md:p-10 rounded-3xl shadow-2xl border border-emerald-500/30 backdrop-blur-md animate-pulse-emerald">
          <div className="flex items-center justify-between pb-4 mb-6 border-b border-slate-800 font-mono text-xs text-slate-400">
            <span>ENDPOINT: <strong className="text-emerald-400">POST /api/v1/contact/dispatch</strong></span>
            <span className="text-emerald-400">STATUS: 200 READY</span>
          </div>

          <div className="mb-6">
            <label htmlFor="name" className="block text-xs font-mono font-bold text-emerald-400 uppercase tracking-wider mb-2">
              Sender Name / Entity <span className="text-emerald-400">*</span>
            </label>
            <input
              type="text"
              id="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="e.g. Sarah Jenkins (CTO at FinTech Corp)"
              className="w-full rounded-2xl bg-slate-950 border border-slate-800 p-4 text-xs font-mono text-slate-100 focus:border-emerald-400 focus:outline-none focus:ring-2 focus:ring-emerald-500/30 transition-all"
              required
            />
          </div>

          <div className="mb-6">
            <label htmlFor="email" className="block text-xs font-mono font-bold text-emerald-400 uppercase tracking-wider mb-2">
              Corporate Email <span className="text-emerald-400">*</span>
            </label>
            <input
              type="email"
              id="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="e.g. sarah.jenkins@fintech.io"
              className="w-full rounded-2xl bg-slate-950 border border-slate-800 p-4 text-xs font-mono text-slate-100 focus:border-emerald-400 focus:outline-none focus:ring-2 focus:ring-emerald-500/30 transition-all"
              required
            />
          </div>

          <div className="mb-8">
            <label htmlFor="message" className="block text-xs font-mono font-bold text-emerald-400 uppercase tracking-wider mb-2">
              Software Architecture Requirements / Message Payload <span className="text-emerald-400">*</span>
            </label>
            <textarea
              id="message"
              rows={5}
              value={formData.message}
              onChange={handleChange}
              placeholder="Share details regarding your tech stack, full-stack microservices architecture, or AI agent development..."
              className="w-full rounded-2xl bg-slate-950 border border-slate-800 p-4 text-xs font-mono text-slate-100 focus:border-emerald-400 focus:outline-none focus:ring-2 focus:ring-emerald-500/30 transition-all resize-y"
              required
            />
          </div>

          <button
            type="submit"
            disabled={submitted}
            className="w-full rounded-2xl bg-gradient-to-r from-emerald-500 to-teal-600 hover:from-emerald-400 hover:to-teal-500 py-4 px-8 font-mono font-extrabold text-xs uppercase tracking-widest text-slate-950 shadow-xl shadow-emerald-500/30 transition-all duration-300 hover:scale-105 disabled:opacity-60"
          >
            {submitted ? "📡 Dispatching API Payload..." : "📡 Dispatch API Request Payload"}
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;